// extracted by mini-css-extract-plugin
export default {"main":"Slider_main__6zSNh","img":"Slider_img__y9pp0"};